/* eslint-disable no-dupe-class-members */
import { Injectable } from '@angular/core';
import { ApiClient } from '../api.client';
import { Observable } from 'rxjs';

interface JobSummary {
  workshop?: number;
  deliveries?: number;
}

const deliveries = {
  deliveries: [
    {
      id: 30,
      deliverable_id: 14,
      deliverable_type: 'booking',
      created_by: 2646,
      due: '2023-10-23T11:00:00+00:00',
      location: '12 Fake Road',
      google_place_id: null,
      fullfillemnt_provider: null,
      external_fulfillment: false,
      items: [
        {
          id: 34,
          deliverable_item_type: 'bookingItem',
          deliverable_item_id: 24,
          delivery_note_description: '1 x STRIMMER'
        }
      ]
    }
  ]
};

export interface DeliveryJobForUser {
  id: number;
  deliverable_id: number;
  deliverable_type: string;
  created_by: number;
  due: string;
  location: string;
  google_place_id: null;
  fullfillemnt_provider: null;
  external_fulfillment: boolean;
  customer: string;
  customer_id: number;
  allocated_to: number;
  created_at: string;
  fulfilled_date: string;
  type: string;
  items: {
    id: number;
    deliverable_item_type: string;
    deliverable_item_id: number;
    delivery_note_description: string;
  }[];
}

export interface WorkshopJobForUser {
  id: number;
  booked_in_at: string;
  site_visit_at: string;
  site_visit_address: string;
  site_place_id: number;
  equipment: string;
  customer_id: number;
  customer_name: string;
  work_status: string;
}

interface Jobs {
  workshop?: WorkshopJobForUser[];
  deliveries?: DeliveryJobForUser[];
}

@Injectable()
export class UserJobsService {
  constructor(private http: ApiClient) {}

  public getJobs(
    userId: number,
    type: string,
    summary: false
  ): Observable<Jobs>;
  public getJobs(
    userId: number,
    type: string,
    summary: true
  ): Observable<JobSummary>;
  public getJobs(
    userId: number,
    type: string,
    summary: boolean
  ): Observable<Jobs | JobSummary> {
    return this.http.get(
      `user-jobs?user_id=${userId}&summary=${summary}&job_type=${type}`
    );
  }

  public getDeliveryJobs(userId: number): Observable<Jobs> {
    return this.getJobs(userId, 'deliveries', false);
  }

  public getWorkshopJobs(userId: number): Observable<Jobs> {
    return this.getJobs(userId, 'workshop', false);
  }
}
